/** Number formatting for the home page */

/** 1234 → "1.2K", 2400000 → "2.4M" */
export const compact = (n: number) =>
  new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(n)

/** 7100 → "$7.1K" */
export const money = (n: number) =>
  n >= 10_000
    ? `$${compact(n)}`
    : `$${new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(n)}`

/** 0.0749 → "7.5%" */
export const percent = (n: number) => `${(n * 100).toFixed(1)}%`

/**
 * A change against the previous period, short enough for a badge. Large jumps read as a
 * multiple ("3.2x"), nothing to compare against reads as "New".
 */
export const changeLabel = (change: number | null) => {
  if (change === null) return 'New'
  if (change >= 200) return `${((change + 100) / 100).toFixed(1)}x`
  return `${change > 0 ? '+' : ''}${change}%`
}

/** "2h ago", "3d ago" */
export const ago = (iso: string) => {
  const mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000))
  if (mins < 60) return `${mins || 1}m ago`
  const hours = Math.round(mins / 60)
  if (hours < 24) return `${hours}h ago`
  return `${Math.round(hours / 24)}d ago`
}

/** "Good morning" / "Good afternoon" / "Good evening" */
export const greeting = (d = new Date()) => {
  const h = d.getHours()
  return h < 12 ? 'Good morning' : h < 18 ? 'Good afternoon' : 'Good evening'
}
